const ENDPOINT = '/api/feedbacks';

const CREATE_FEEDBACK = 'feedbacks/CREATE_FEEDBACK';
const CREATE_FEEDBACK_SUCCESS = 'feedbacks/CREATE_FEEDBACK_SUCCESS';
const CREATE_FEEDBACK_FAIL = 'feedbacks/CREATE_FEEDBACK_FAIL';

function serializeFeedback(feedback) {
  const { leasedByAB, ...rest } = feedback;
  return {
    leasedByAB: leasedByAB || null,
    ...rest
  };
}

export function create(data) {
  const serializedData = serializeFeedback(data);
  return {
    types: [CREATE_FEEDBACK, CREATE_FEEDBACK_SUCCESS, CREATE_FEEDBACK_FAIL],
    promise: (client) => client.post(`${ENDPOINT}`, { data: serializedData })
  };
}
